export const KLAVIYO_EVENTS_NAME = {
  KL_IDENTIFY: 'identify',
  KL_ADDED_TO_CART: 'Added to Cart',
  KL_STARTED_CHECKOUT: 'Started Checkout',
  KL_VIEWED_PRODUCT: 'Viewed Product',
};

// 1	identify
// 2	Viewed Product
// 3	Added to Cart
// 4	Started Checkout
